import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Caption } from '@xo-union/tk-ui-typography';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import RsvpDropdown from '~/glm/components/guest-list/header/rsvp-filter-dropdown';
import EventCollection from '~/glm/models/gds/event-collection';
import styles from './overview-rsvp-dropdown-contents.scss';

@inject('gdsUiState')
@observer
class OverviewRsvpDropdownContents extends React.Component {
  static propTypes = {
    rsvpFilter: PropTypes.func,
    events: PropTypes.instanceOf(EventCollection),
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    setMenuState: PropTypes.func,
    type: PropTypes.oneOf(['filter', 'selection']),
  };

  filterOutReception = event => {
    return event.type !== 'Reception';
  };

  render() {
    const { rsvpFilter, type, events, gdsUiState, setMenuState } = this.props;
    const { rsvpBulkSelectedEvent, rsvpFilteredEvent, rsvpFilter: rsvpFilterValue, rsvpBulkSelection } = gdsUiState;
    const selectedFilterData = gdsUiState.rsvpFilter;
    let selectedEvent;
    let selectedValue;

    if (type === 'filter') {
      selectedEvent = rsvpFilteredEvent;
      selectedValue = rsvpFilterValue;
    } else if (type === 'selection') {
      selectedEvent = rsvpBulkSelectedEvent;
      selectedValue = rsvpBulkSelection;
    }

    return (
      <Fragment>
        {events.filter(this.filterOutReception).map(event => (
          <div key={event.id}>
            {events.size > 1 && <Caption className={styles.sectionHeader}>{event.name} </Caption>}
            <RsvpDropdown
              rsvpFilter={rsvpFilter}
              setSelectedFilterData={selectedFilterData}
              currentSelection={selectedEvent && selectedEvent.id === event.id ? selectedValue : null}
              setMenuState={setMenuState}
              event={event}
              border={false}
              showNotInvited={true}
            />
          </div>
        ))}
      </Fragment>
    );
  }
}

export default OverviewRsvpDropdownContents;
